import React from 'react';

const ReviewRequestTextSvg = ({ color = '#000', size = 18, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="none" {...props}>
        <path
            d="M16.2 0H1.8C0.8073 0 0 0.816816 0 1.82122V12.7485C0 13.7529 0.8073 14.5697 1.8 14.5697H4.5V18L10.1493 14.5697H16.2C17.1927 14.5697 18 13.7529 18 12.7485V1.82122C18 0.816816 17.1927 0 16.2 0ZM16.2 12.7485H9.6507L6.3 14.7819V12.7485H1.8V1.82122H16.2V12.7485Z"
            fill={color}
            fillOpacity="0.87"
        />
    </svg>
);

export default ReviewRequestTextSvg;
